import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react'
import { useCallback, useEffect, useRef, useState } from 'react'
import Header from './UI/Header'
import Footer from './UI/Footer'
import SectionHeading from './UI/SectionHeading'
import ListItem from './UI/ListItem'
import { useContext } from 'react'
import { NavbarContext } from '../../Context/NavbarContext'
import { generateLink } from '../Layouts/NavbarLayout'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { ask, contextSearch, searchEvents } from '../../Api/search'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import { DateTime } from 'luxon'
import Feedback from '../Feedback/Feedback2'
import { GetStartedContext } from '../../Context/GetStartedContext'
import { useSelector } from 'react-redux'
import { removePrefix } from '../FunctionDashboard/FunctionDashboard'

// const optionTypes = ['ask', 'answer']
const filterTypes = [
  'functionFilter',
  'tagFilter',
  'recurringEventFilter',
  'meeting',
]

const getFilterTypeFromEvent = (name) => {
  if (name.startsWith('function_')) {
    return filterTypes[0]
  }
  if (name.startsWith('event_')) {
    return filterTypes[3]
  }
  if (name.startsWith('tag_')) {
    return filterTypes[1]
  }
  if (name.startsWith('rec_')) {
    return filterTypes[2]
  }
}

const loadMeetings = async (search) => {
  if (!search) return
  const apiResponse = await searchEvents(search)
  // console.log(apiResponse)
  return apiResponse
}

const debouncedLoadMeetings = AwesomeDebouncePromise(loadMeetings, 600)

const getDisplayDateFromMeeting = (meeting) => {
  const timestamp = meeting.start_time
  let dateTime = DateTime.fromMillis(parseInt(timestamp))
  if (meeting.event_id.split('_').at(-1).endsWith('000Z')) {
    const tz = meeting.event_id.split('_').at(-1)
    dateTime = DateTime.fromObject({
      year: parseInt(tz[0] + tz[1] + tz[2] + tz[3]),
      month: parseInt(tz[4] + tz[5]),
      day: parseInt(tz[6] + tz[7]),
      hour: parseInt(dateTime.toFormat('H')),
      minute: parseInt(dateTime.toFormat('m')),
    })
  }
  const day = dateTime.toFormat('MMM dd')
  return day
}

const Ask = ({ isOpen, onClose, setIsOpen }) => {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const searchInputRef = useRef(null)
  const resultsRef = useRef(null)
  const navigate = useNavigate()

  const user = useSelector((state) => state?.user.data)
  const { currentStep, moveToNextStep } = useContext(GetStartedContext)

  const { dashboardFunctions, recurringEvents, dashboardTags, setCurrentPath } =
    useContext(NavbarContext)

  const [tooltip2Open, setTooltip2Open] = useState(true)
  const [tooltip3Open, setTooltip3Open] = useState(true)

  const [question, setQuestion] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [activeOptionIndex, setActiveOptionIndex] = useState(0)
  const [recentOptionIndex, setRecentOptionIndex] = useState(-1)
  const [recentOptions, setRecentOptions] = useState([])
  const [options, setOptions] = useState([
    { id: 'ask', type: 'ask', title: '', isActive: false },
    { id: 'answer', type: 'answer', title: '', isActive: false },
    {
      id: 'newQuestion',
      type: 'newQuestion',
      title: 'New Question...',
      isActive: false,
    },
  ])

  const [filter, setFilter] = useState({ id: '' })
  const [filterTo, setFilterTo] = useState({ id: '' })
  const [recentOptionFilterTo, setRecentOptionFilterTo] = useState({ id: '' })

  const [questionId, setQuestionId] = useState('')

  const askOption = options[0]
  const answerOption = options[1]
  const newQuestionCommand = options[2]
  const showNavigate = true

  useEffect(() => {
    // if (currentStep === 2.5) {
    //   updateAskOptionTitle('')
    //   updateOptionTitle('', 1)
    //   setActiveOptionIndex(0)
    //   setRecentOptions([
    //     {
    //       id: `${user.id}_google_first_meeting`,
    //       type: 'meeting',
    //       title: 'Start with Arrowhead! 🏹🚀',
    //       isActive: true,
    //     },
    //   ])
    //   setRecentOptionIndex(0)
    //   setFilterTo({ id: '' })
    //   setRecentOptionFilterTo({ id: '' })
    //   setQuestion('')
    //   setFilter({ id: '' })
    //   // setIsOpen(true)
    //   return
    // }

    if (!isOpen) {
      return
    }
    // if (currentStep === 1) {
    //   setRecentOptions([
    //     {
    //       id: `What are ${user?.name}’s action items?`,
    //       type: 'ask',
    //       title: `What are ${user?.name}’s action items?`,
    //       isActive: true,
    //     },
    //   ])
    //   setRecentOptionIndex(0)
    //   return
    // } else if (currentStep === 4) {
    //   if (location.pathname === '/transcripts-summaries/summary') {
    //     const eventParam = searchParams.get('eventId')
    //     if (eventParam === `${user.id}_google_first_meeting`) {
    //       setFilter({
    //         id: 'onboardingDefault',
    //         type: 'meeting',
    //         title: 'Start with Arrowhead! 🏹🚀',
    //         label: 'Start with Arrowhead! 🏹🚀',
    //       })
    //       setRecentOptions([
    //         {
    //           id: 'Summarize the main objectives and goals in this meeting',
    //           type: 'ask',
    //           title: 'Summarize the main objectives and goals in this meeting',
    //           isActive: true,
    //         },
    //       ])
    //       setRecentOptionIndex(0)
    //     }
    //     return
    //   }
    // }
    const recentItems = localStorage.getItem('recentItems')
    if (recentItems) {
      setRecentOptions(
        JSON.parse(recentItems).map((option, i) => {
          if (i === 0) return { ...option, isActive: true }
          return { ...option, isActive: false }
        })
      )
      setRecentOptionIndex(0)
    }
    if (
      location.pathname === '/transcripts-summaries/summary' ||
      location.pathname === '/transcripts-summaries/transcript'
    ) {
      const eventId = searchParams.get('eventId')
      const name = searchParams.get('eventName')
      const filterType = filterTypes[3]
      setFilter({ id: eventId, type: filterType, title: name, label: name })
      return
    }

    if (location.pathname === '/transcripts-summaries/dashboard') {
      const eventId = searchParams.get('name')
      const name = removePrefix(eventId)
      const filterType = getFilterTypeFromEvent(eventId)
      setFilter({ id: eventId, type: filterType, title: name, label: name })
      return
    }
  }, [
    isOpen,
    user,
    location,
  ]) /* we need to add this if we want ask arr in future currentStep*/

  const resetAndClose = () => {
    updateAskOptionTitle('')
    updateOptionTitle('', 1)
    setActiveOptionIndex(0)
    setRecentOptionIndex(0)
    setFilterTo({ id: '' })
    setRecentOptionFilterTo({ id: '' })
    setQuestion('')
    setFilter({ id: '' })
    onClose()
  }

  // useEffect(() => localStorage.setItem('recentItems', null), [])

  // useEffect(() => {
  //   console.log(recentOptions)
  // }, [recentOptions])

  const updateAskOptionTitle = (text) => {
    const optionsCopy = [...options]
    optionsCopy[0].title = text
    setOptions(optionsCopy)
    setActiveOptionIndex(0)
    filterOptions(text)
  }

  const updateOptionTitle = (text, index) => {
    const optionsCopy = [...options]
    optionsCopy[index].title = text
    setOptions(optionsCopy)
  }

  useEffect(() => {
    const optionsCopy = options.map((option) => ({
      ...option,
      isActive: false,
    }))
    if (activeOptionIndex > -1 && activeOptionIndex < options.length) {
      optionsCopy[activeOptionIndex].isActive = true

      if (activeOptionIndex > 2) {
        setFilterTo({
          ...optionsCopy[activeOptionIndex],
          label: optionsCopy[activeOptionIndex].title,
          subLabel: optionsCopy[activeOptionIndex].date,
        })
      } else if (askOption.title && options.length > 3) {
        setFilterTo({
          ...optionsCopy[3],
          label: optionsCopy[3].title,
          subLabel: optionsCopy[activeOptionIndex].date,
        })
      } else {
        setFilterTo({ id: '' })
      }
    }

    setOptions(optionsCopy)
  }, [activeOptionIndex])

  useEffect(() => {
    const recentOptionsCopy = recentOptions.map((option) => ({
      ...option,
      isActive: false,
    }))
    if (
      recentOptionIndex > -1 &&
      recentOptionIndex < recentOptionsCopy.length
    ) {
      recentOptionsCopy[recentOptionIndex].isActive = true

      if (
        filterTypes.find(
          (type) => recentOptionsCopy[recentOptionIndex].type === type
        )
      ) {
        setRecentOptionFilterTo({
          ...recentOptionsCopy[recentOptionIndex],
          label: recentOptionsCopy[recentOptionIndex].title,
          subLabel: recentOptionsCopy[recentOptionIndex].date,
        })
      } else {
        setRecentOptionFilterTo({ id: '' })
      }
    } else {
      setRecentOptionFilterTo({ id: '' })
    }

    setRecentOptions(recentOptionsCopy)
  }, [recentOptionIndex])

  const getFilterTo = () => {
    if (!askOption.title) {
      return recentOptionFilterTo
    }
    return filterTo
  }

  const handleClearQuestion = () => {
    updateAskOptionTitle('')
    updateOptionTitle('', 1)
    setQuestion('')
    setFilter({ id: '' })
  }

  const handleOptionSelect = (selectedOption) => {
    let option
    if (!selectedOption) {
      let index = activeOptionIndex
      let availableOptions = options

      if (!answerOption.title && !askOption.title) {
        index = recentOptionIndex
        availableOptions = recentOptions
        const filter = availableOptions[index].withFilter
        if (filter && filter.id) {
          setFilter(filter)
        }
      } else if (answerOption.title && index === 0) {
        index = 1
      }

      if (index < 0 || index > availableOptions.length - 1) return
      option = availableOptions[index]
    } else {
      option = selectedOption
    }

    if (option.type === 'newQuestion') {
      handleClearQuestion()
      return
    }

    if (option.type === 'ask') {
      setIsLoading(true)
      setQuestion(option.title)
      saveOptionToRecentItems({ ...option, id: option.title })
      setRecentOptionIndex(0)
      setActiveOptionIndex(0)
    }

    if (
      option.type === 'functionFilter' ||
      option.type === 'tagFilter' ||
      option.type === 'recurringEventFilter'
    ) {
      let generateLinkId = 'dashboardFunctions'
      if (option.type === 'tagFilter') generateLinkId = 'dashboardTags'
      if (option.type === 'recurringEventFilter')
        generateLinkId = 'recurringEvents'

      const path = generateLink(generateLinkId, option.id, option.title)
      saveOptionToRecentItems(option)
      navigate(path)
      setCurrentPath(['dashboard', option.id])
      resetAndClose()
    }

    if (option.type === 'meeting') {
      // if (currentStep === 2.5) {
      //   moveToNextStep(2)
      // }
      let id = option.id
      if (id.startsWith(('event_'))) {
        id = id.substring(6)
      }
      const path = `/transcripts-summaries/summary?eventId=${id}&tab=HIGH&eventName=${option.title}`
      saveOptionToRecentItems(option)
      navigate(path)
      setCurrentPath(['dashboard', option.id])
      resetAndClose()
    }
  }

  const handleTabPress = () => {
    const filterTo = getFilterTo()
    // console.log(filter)
    if (filter.id || !filterTo.id) return
    setFilter({ ...filterTo })
    updateAskOptionTitle('')
    setActiveOptionIndex(0)
    setRecentOptionIndex(0)
    setFilterTo({ id: '' })
    setRecentOptionFilterTo({ id: '' })
  }

  const saveOptionToRecentItems = (option) => {
    // const recentOptionsCopy = recentOptions.filter(o => o.id === 'ask' || o.id !== option.id)
    // TODO see if each ask is to be treated seperately
    const recentOptionsCopy = recentOptions.filter((o) => o.id !== option.id)
    const optionCopy = { ...option }
    if (optionCopy.type === 'ask' && filter && filter.id) {
      optionCopy['withFilter'] = filter
    }
    const updatedRecentItems = [optionCopy, ...recentOptionsCopy].map((o) => ({
      ...o,
      isActive: false,
    }))

    updatedRecentItems[0].isActive = true
    if (filterTypes.find((type) => updatedRecentItems[0].type === type)) {
      setRecentOptionFilterTo({
        ...updatedRecentItems[0],
        label: updatedRecentItems[0].title,
        subLabel: updatedRecentItems[0].date,
      })
    } else {
      setRecentOptionFilterTo({ id: '' })
    }

    if (updatedRecentItems.length > 3) {
      updatedRecentItems.splice(3, 1)
    }
    setRecentOptions(updatedRecentItems)
    localStorage.setItem('recentItems', JSON.stringify(updatedRecentItems))
  }

  const askQuestion = useCallback(async () => {
    // console.log(filter)
    if (!question) return
    const response = await ask(question, undefined, [filter.id])
    if (response && response.answer && response.answer.length) {
      updateOptionTitle(response.answer[0].answer, 1)
      setQuestionId(response.questionId)
    } else {
      updateOptionTitle('NO ANSWER', 1)
    }
    setIsLoading(false)
  }, [question, filter])

  useEffect(() => {
    // console.log(question)
    if (question && isLoading) {
      // console.log(filter, filter.id)
      //       if (currentStep === 1) {
      //         setTimeout(() => {
      //           setIsLoading(false)
      //           updateOptionTitle(
      //             `<<<div;;;Awesome! Here’s an example of how Arrowhead can create a list of todos from a meeting you’ve had.
      // <<<br;;;
      // <<<ul;;;Review project scope and provide feedback;;
      // Update the team on recent client communication;;
      // Outline key milestones and assign deadlines;;
      // Prepare a presentation on product features;;
      // Collaborate with the design team on UI/UX improvements;;
      // Analyze competitor products and identify unique selling points
      // `,
      //             1
      //           )
      //           moveToNextStep(1)
      //         }, 2000)
      //         return
      //       }
      //       if (currentStep === 4) {
      //         setTimeout(() => {
      //           setIsLoading(false)
      //           updateOptionTitle(
      //             `<<<div;;;In the cheerful 'Start with Arrowhead' meeting, our fantastic founder Devyani gave us a delightful walkthrough of the product.
      // Here are the main objectives and goals we covered during this fun and informative session:
      // <<<ol;;;Warmly welcome everyone and introduce the passionate team members.;;
      // Share the inspiring vision and mission behind the product.;;
      // Provide a friendly, step-by-step guide to using the product's amazing features.;;
      // Highlight how the product uniquely solves users' problems and makes their lives easier.;;
      // Discuss some exciting upcoming updates and improvements to the product.;;
      // Answer any questions and address concerns with a caring and helpful attitude.;;
      // Encourage team members to share their own creative ideas and feedback to make the product even better.;;
      // The 'Start with Arrowhead' meeting left us all feeling inspired and excited about the product, and eager to contribute to its success!`,
      //             1
      //           )
      //           moveToNextStep(4)
      //         }, 2000)
      //         return
      //       }
      askQuestion()
    }
  }, [question]) // add currentStep if in future we want ask arrw

  const filterOptions = async (searchText) => {
    // console.log(searchText)
    if (!searchText) {
      // console.log('rem filter to')
      setFilterTo({ id: '' })
      setOptions([askOption, answerOption, newQuestionCommand])
      setActiveOptionIndex(0)
      return
    }

    const meetings = (await debouncedLoadMeetings(searchText)).map((m) => ({
      id: `event_${m.event_id}`,
      type: 'meeting',
      title: m.title,
      isActive: false,
      date: getDisplayDateFromMeeting(m),
    }))
    // console.log('mmm', meetings)

    const lowerCaseSearchText = searchText.toLowerCase()
    // const functionFilters = (dashboardFunctions ?? [])
    //   .filter((item) => item.name.toLowerCase().includes(lowerCaseSearchText))
    //   .map((filter) => ({
    //     id: `function_${filter.id}`,
    //     type: 'functionFilter',
    //     title: filter.name,
    //     isActive: false,
    //   }))

    const recurringEventFilters = (recurringEvents ?? [])
      .filter((item) => item.name.toLowerCase().includes(lowerCaseSearchText))
      .map((filter) => ({
        id: `rec_${filter.id.substring(4)}`,
        type: 'recurringEventFilter',
        title: filter.name,
        isActive: false,
      }))

    // const tagFilters = (dashboardTags ?? [])
    //   .filter((item) => item.name.toLowerCase().includes(lowerCaseSearchText))
    //   .map((filter) => ({
    //     id: `tag_${filter.id.substring(4)}`,
    //     type: 'tagFilter',
    //     title: filter.name,
    //     isActive: false,
    //   }))

    // console.log(functionFilters, recurringEventFilters, tagFilters)
    const options = [
      { ...askOption, isActive: true },
      answerOption,
      newQuestionCommand,
      // ...functionFilters,
      // ...tagFilters,
      ...recurringEventFilters,
      ...meetings,
    ]
    setOptions(options)

    if (options.length > 3) {
      // console.log('s')
      setFilterTo({
        ...options[3],
        label: options[3].title,
        subLabel: options[3].date,
      })
    } else {
      setFilterTo({ id: '' })
    }
  }

  const scrollResults = (event) => {
    if (answerOption.title) return

    if (resultsRef.current) {
      if (event.key === 'ArrowDown') {
        resultsRef.current.scrollTo(0, resultsRef.current.scrollTop + 51)
      } else {
        resultsRef.current.scrollTo(0, resultsRef.current.scrollTop - 51)
      }
    }
  }

  const handleNavigation = (event) => {
    scrollResults(event)

    if (
      event.key === 'ArrowDown' &&
      recentOptionIndex < recentOptions.length - 1
    ) {
      setRecentOptionIndex(recentOptionIndex + 1)
    }
    if (event.key === 'ArrowUp' && recentOptionIndex > 0) {
      setRecentOptionIndex(recentOptionIndex - 1)
    }

    if (event.key === 'ArrowDown' && activeOptionIndex < options.length - 1) {
      if (activeOptionIndex === 0) {
        if (!answerOption.title) {
          setActiveOptionIndex(3)
          return
        }
        setActiveOptionIndex(2)
        return
      }
      setActiveOptionIndex(activeOptionIndex + 1)
    }
    if (event.key === 'ArrowUp' && activeOptionIndex > 0) {
      if (activeOptionIndex === 3 && !answerOption.title) {
        setActiveOptionIndex(0)
        return
      }
      if (activeOptionIndex === 1 && answerOption.title) {
        setActiveOptionIndex(1)
        return
      }
      setActiveOptionIndex(activeOptionIndex - 1)
    }
  }

  const renderAskOption = () => {
    // if (isLoading || !askOption || !askOption.title || answerOption.title)
    //   return

    return


    // if (isLoading || !askOption || !askOption.title || answerOption.title)
    //   return

    // return (
    //   <>
    //     <SectionHeading title={'SEARCH'} />
    //     <ListItem
    //       option={askOption}
    //       onClick={() => handleOptionSelect(askOption)}
    //     />
    //   </>
    // )
  }

  const renderAnswerOption = () => {
    if (!answerOption.title) return

    return (
      <>
        <SectionHeading
          title={
            answerOption.title === 'NO ANSWER'
              ? `NO RESULTS FOR "${question}"`
              : `"${question}"`
          }
        />
        {answerOption.title === 'NO ANSWER' ? (
          <></>
        ) : (
          <ListItem
            isNotClickable
            option={{ ...answerOption, isActive: true }}
            onClick={() => handleOptionSelect(answerOption)}
          />
        )}
        {/* TODO pass question id */}
        <Feedback
          reference_id={searchParams.get('eventId')}
          feedback_type={1}
        />
        <Flex minH={2} flexDirection='column' justifyContent='flex-start'>
          <Box bg='#E0E0E0' h='1px' w='full' opacity='0.4' />
        </Flex>
        <ListItem
          isNotClickable
          option={{ ...newQuestionCommand, isActive: false }}
        />
      </>
    )
  }

  const renderRecentOptions = () => {
    if (!recentOptions || !recentOptions.length) return <></>
    return (
      <>
        <SectionHeading
          title={
            // currentStep === 1 || currentStep === 4 ? 'Suggestions' :
            'Recent'
          }
        />
        {recentOptions.map((option) => {
          return (
            <ListItem
              key={`recent-${option.id}`}
              option={option}
              onClick={() => handleOptionSelect(option)}
            />
          )
        })}
      </>
    )
  }

  const renderOptions = () => {
    if (isLoading || answerOption.title) return
    if (!askOption.title) {
      return renderRecentOptions()
    }

    if (options.length < 4) return
    return (
      <>
        <SectionHeading title={'Results'} />
        {options.map((option, i) => {
          if (i < 3) return <></>
          return (
            <ListItem
              key={option.id}
              option={option}
              onClick={() => handleOptionSelect(option)}
            />
          )
        })}
      </>
    )
  }

  useEffect(() => {
    if (question === '' && searchInputRef && searchInputRef.current) {
      searchInputRef.current.focus()
    }
  }, [question, searchInputRef])

  return (
    <>
      {/* {isOpen && currentStep === 1 && !isLoading && !answerOption.title ? (
        <Flex
          position='fixed'
          top='206px'
          zIndex={100000}
          justifyContent='flex-end'
          left='calc(50vw - 282px - 346px)'
        >
          <Flex bg='white' py='9px' px='12px' borderRadius='8px' maxW='282px'
            border='1px solid #EAEAEA'
            boxShadow='0px 14px 6px rgba(0, 0, 0, 0.01), 0px 8px 5px rgba(0, 0, 0, 0.02), 0px 4px 4px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          > 
            <Text color='#222222' fontSize='14px' lineHeight='16.94px'>
            💡 Ask Arrowhead anything about a past meeting. 
            <br /><br />
            Try a suggested question! 
            </Text>
            <Box
              position='absolute'
              right='-16px'
              top='10px'
              width={0}
              height={0}
              borderWidth='16px 0 16px 30px'
              borderColor='transparent transparent transparent white'
              borderStyle='solid'
            />
          </Flex>
        </Flex>
      ) : (
        <></>
      )} */}
      {/* {isOpen && tooltip2Open && currentStep === 2 && !isLoading ? (
        <Flex
          position='fixed'
          bottom={3}
          right={3}
          zIndex={10000}
          justifyContent='flex-end'
        >
          <Flex
            bg='white'
            py='20px'
            px='20px'
            borderRadius='8px'
            w='345px'
            flexDirection='column'
            position='relative'
          >
            <Flex position='absolute' top='13px' right='13px'>
              <Image
                opacity='0.4'
                boxSize={3}
                color='brandTextBlack'
                src='/assets/icons/cancel.svg'
                cursor='pointer'
                onClick={() => setTooltip2Open(false)}
              />
            </Flex>
            <Flex mt='16px'>
              <Image src='/assets/images/magicSearch.svg' />
            </Flex>
            <Text
              mt={4}
              color='#222222'
              fontSize='16px'
              lineHeight='19.36px'
              fontWeight='700'
            >
              You&apos;ve experienced our magic search!
            </Text>
            <Text
              mt={4}
              color='#222222'
              fontSize='16px'
              lineHeight='24px'
              fontWeight='500'
            >
              Hooray! You&apos;ve unlocked your 1st AI-generated answer! 🥳 Keep
              up the great work and let Arrowhead continue to enhance your
              meeting experience.
            </Text>
            
          </Flex>
        </Flex>
      ) : (
        <></>
      )}
      {isOpen && currentStep === 2.5 && !isLoading && !answerOption.title ? (
        <Flex
          position='fixed'
          top='206px'
          zIndex={100000}
          justifyContent='flex-end'
          left='calc(50vw - 282px - 346px)'
        >
          <Flex bg='white' py='9px' px='12px' borderRadius='8px' maxW='282px'
            border='1px solid #EAEAEA'
            boxShadow='0px 14px 6px rgba(0, 0, 0, 0.01), 0px 8px 5px rgba(0, 0, 0, 0.02), 0px 4px 4px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          > 
            <Text color='#222222' fontSize='14px' lineHeight='16.94px'>
            💡 Try clicking on the suggested meeting to continue
            </Text>
            <Box
              position='absolute'
              right='-16px'
              top='10px'
              width={0}
              height={0}
              borderWidth='16px 0 16px 30px'
              borderColor='transparent transparent transparent white'
              borderStyle='solid'
            />
          </Flex>
        </Flex>
      ) : (
        <></>
      )}
      {isOpen &&
      tooltip3Open &&
      currentStep === 4 &&
      !isLoading &&
      !answerOption.title ? (
        <Flex
          position='fixed'
          top='104px'
          zIndex={100000}
          justifyContent='flex-end'
          left='calc(50vw - 282px - 212px)'
        >
          <Flex bg='white' py='9px' px='12px' borderRadius='8px' maxW='147px'
            border='1px solid #EAEAEA'
            boxShadow='0px 14px 6px rgba(0, 0, 0, 0.01), 0px 8px 5px rgba(0, 0, 0, 0.02), 0px 4px 4px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          > 
            <Text color='#222222' fontSize='14px' lineHeight='16.94px'>
            💡 Filter auto-set to this meeting 
            </Text>
            <Box
              position='absolute'
              right='-16px'
              top='10px'
              width={0}
              height={0}
              borderWidth='16px 0 16px 30px'
              borderColor='transparent transparent transparent white'
              borderStyle='solid'
            />
          </Flex>
        </Flex>
      ) : (
        <></>
      )}
      {isOpen &&
      tooltip3Open &&
      currentStep === 4 &&
      !isLoading &&
      !answerOption.title ? (
        <Flex
          position='fixed'
          top='206px'
          zIndex={100000}
          justifyContent='flex-end'
          left='calc(50vw - 282px - 212px)'
        >
          <Flex bg='white' py='9px' px='12px' borderRadius='8px' maxW='147px'
            border='1px solid #EAEAEA'
            boxShadow='0px 14px 6px rgba(0, 0, 0, 0.01), 0px 8px 5px rgba(0, 0, 0, 0.02), 0px 4px 4px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          > 
            <Text color='#222222' fontSize='14px' lineHeight='16.94px'>
              Try the suggested question!
            </Text>
            <Box
              position='absolute'
              right='-16px'
              top='10px'
              width={0}
              height={0}
              borderWidth='16px 0 16px 30px'
              borderColor='transparent transparent transparent white'
              borderStyle='solid'
            />
          </Flex>
        </Flex>
      ) : (
        <></>
      )} */}
      <AlertDialog
        isOpen={isOpen}
        onClose={() => {
          resetAndClose()
        }}
        onEsc={() => {
          resetAndClose()
        }}
      >
        <AlertDialogOverlay
          bg={
            // (isOpen &&
            //   currentStep === 1 &&
            //   !isLoading &&
            //   !answerOption.title) ||
            // (isOpen &&
            //   currentStep === 2.5 &&
            //   !isLoading &&
            //   !answerOption.title) ||
            // (isOpen &&
            //   tooltip3Open &&
            //   currentStep === 4 &&
            //   !isLoading &&
            //   !answerOption.title)
            //   ? 'rgba(0,0,0,0.6)'
            //   :
            'rgba(225, 225, 225, 0.6)'
          }
        />
        <AlertDialogContent
          borderRadius='20px'
          p={0}
          maxW='658px'
          minH='173px'
          maxH='462px'
          display='flex'
          flexDirection='column'
          onKeyDown={(event) => {
            // if (event.key === 'Tab') {
            //   event.preventDefault()
            //   handleTabPress()
            // }
            if (event.key === 'Enter') {
              event.preventDefault()
              handleOptionSelect()
            }
            if (event.key === 'n') {
              if (
                document.activeElement.tagName !== 'INPUT' &&
                question &&
                activeOptionIndex > -1 &&
                activeOptionIndex < 3
              ) {
                event.preventDefault()
                handleOptionSelect(newQuestionCommand)
              }
            }
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault()
              handleNavigation(event)
            }
          }}
          mt='100px'
        >
          <Header
            searchText={askOption.title}
            onSearchTextChange={(e) => {
              updateAskOptionTitle(e.target.value)
            }}
            question={question}
            isLoading={isLoading}
            clearQuestion={() => {
              handleClearQuestion()
            }}
            filter={filter}
            clearFilter={() => {
              setFilter({ id: '' })
              setRecentOptionIndex(0)
              setActiveOptionIndex(0)
            }}
            filterTo={getFilterTo()}
            searchInputRef={searchInputRef}
          />

          <Flex
            flexDirection='column'
            overflow='scroll'
            pb={2}
            flex={1}
            className='noScrollbar'
            ref={resultsRef}
          >
            {renderAskOption()}
            {renderAnswerOption()}
            {renderOptions()}
          </Flex>

          <Footer showNavigate={showNavigate} />
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

export default Ask
